import { Model } from 'backbone';
import { getLogger } from '../../logging/logger';
import { ATTRIBUTES as BASE_ATTRIBUTES, EVENTS } from '../baseGame';

const logger = getLogger('ArcadeModel');

export const ATTRIBUTES = Object.freeze({
	...BASE_ATTRIBUTES,
	analytics: 'analytics',
	arcadeName: 'arcadeName',
	disableHeader: 'disableHeader',
	entitlementEntity: 'entitlementEntity',
	skin: 'skin',
	skinModules: 'skinModules',
});
export { EVENTS };

/**
 * @typedef {Object} ArcadeModelOptions
 * @property {string} arcadeName The arcade name used for logging and analytics purposes
 * @property {string} contentUrl The url for the JSON data file to load
 */

export default class ArcadeModel extends Model {
	defaults() {
		return {
			/** @type {string} The name (aka ID) of the arcade used for analytics and database purposes */
			[ATTRIBUTES.arcadeName]: '',
			/** @type {boolean} Flag to indicate if the header should be ommited from the arcade */
			[ATTRIBUTES.disableHeader]: false,
			/**
			 * @deprecated
			 * @type {object}
			 * Data used to populate the Google Universal Analytics
			 */
			[ATTRIBUTES.analytics]: {},
			/** @type {string} A space seperated string of names of css skins to be loaded dynamically at runtime */
			[ATTRIBUTES.skin]: '',
			/** @type {string} A space seperated string of class names that should be added to the body of the arcade for special styling */
			[ATTRIBUTES.skinModules]: '',
			/** @type {string} The value to be used for checking if a user has any entitlments for a particular platform (aka cable provider) */
			[ATTRIBUTES.entitlementEntity]: '',
			/** @type {object[]} The pages for the arcade */
			[ATTRIBUTES.pages]: [],
		};
	}

	url() {
		return this.get(ATTRIBUTES.contentUrl);
	}

	initialize() {
		logger.log(`[${this.initialize.name}]`);

		return Promise.resolve()
			.then(() => {
				if (this.url()) {
					return this.fetch();
				}
				return Promise.resolve();
			})
			.then(() => {
				this.hydratePagesData();
				this.initialized = true;
				this.trigger(EVENTS.initialized);
				return this;
			});
	}

	hydratePagesData() {
		logger.log(`[${this.hydratePagesData.name}]`);

		const { pages = [] } = this.pick(ATTRIBUTES.pages);
		pages.forEach((page) => {
			page.pages = page.pages || [];
			page.pages = page.pages
				.map((pageId) => {
					if (typeof pageId === 'object') return pageId;
					const targetPage = pages.find(({ id }) => id === pageId);
					if (!targetPage) {
						logger.warn('Cannot find page', { pageId });
					}
					return targetPage;
				})
				.filter((value) => !!value);
		});

		return this;
	}
}
